import { Component, OnInit, ViewChild, AfterViewInit  } from '@angular/core'
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { CoreTranslationService } from '@core/services/translation.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CoreConfigService } from '@core/services/config.service';
import { ColumnMode, DatatableComponent, id } from '@swimlane/ngx-datatable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { ApiService } from 'app/main/services/Api/api.service'
import { MediaService } from 'app/main/services/Media/media.service'
import { HttpErrorResponse } from '@angular/common/http'
import { ToastService } from 'app/main/services/Toast/toast.service'
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms'

@Component({
  selector: 'app-event-categories',
  templateUrl: './event-categories.component.html',
  styleUrls: ['./event-categories.component.scss']
})
export class EventCategoriesComponent implements OnInit {

  public contentHeader: object
  eventCats: any
  eventCatForm: FormGroup
  tempCategoryGuid: string = ''
  uploadedImagePath: string = ''
  isUploadingImage: boolean = false;
  isSavedSuccess: boolean = false;

  /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(private _coreTranslationService: CoreTranslationService,
    private modalService: NgbModal,private api: ApiService,
    private mediaService: MediaService,public toastService: ToastService,
    private formBuilder: FormBuilder) {
      this.eventCatForm = this.formBuilder.group({
        id: [''],
        nameAr: ['',[Validators.required,this.arabicTextValidator]],
        nameEn: ['',[Validators.required,this.englishTextValidator]],
        image: ['',[Validators.required]]
      })
    this._coreTranslationService.translate(en, fr, de, pt)
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  ngOnInit() {
    document.getElementById('الرئيسية')?.classList.remove('active')
    document.getElementById('الفعاليات')?.classList.remove('active')
    document.getElementById('المشرفين')?.classList.remove('active')
    document.getElementById('المستخدمين')?.classList.remove('active')
    document.getElementById('طلبات المشرفين')?.classList.remove('active')
    // document.getElementById('الإشعارات')?.classList.remove('active')
    document.getElementById('العروض')?.classList.remove('active')
    document.getElementById('المسئولين')?.classList.remove('active')

    this.columns = [
      {
          prop: 'selected',
          name: '',
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 50
      },
      { prop: '#' },
      { prop: 'nameAr', name: 'اسم الفئة بالعربية' },
      { prop: 'nameEn', name: 'اسم الفئة بالانجليية' },
      { prop: 'image', name: 'الأيكونة' },
      { prop: '' }
    ];
    this.api.showAllEventCategory(1, 100).subscribe({
      next: (response) => {
          // Map API response to match the table structure
          console.log(response.data.data)
          this.rows = response.data.data.map((item, index) => ({
              id: item.id,
              "#": index + 1, // Assign a sequential number
              nameAr: item.nameAr,
              nameEn: item.nameEn,
              image: item.image
          }));

          this.temp = [...this.rows]; // Store original data
      },
      error: (error: HttpErrorResponse) => {
          console.error("Error fetching event categories:", error);
      }
    });
    this.temp = this.rows

    this.contentHeader = {
      headerTitle: 'فئات المشرفين',
      actionButton: false
    }
  }

  // table
  public readonly pageLimitOptions = [
    {value: 5},
    {value: 10},
    {value: 25},
    {value: 50},
    {value: 100},
  ];
  public chkBoxSelected = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  ColumnMode = ColumnMode;
  columns = []
  customChkboxOnSelect({ selected }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';
  
    // Filter data by checking all columns
    const temp = this.temp.filter((row) => {
      return Object.keys(row).some((key) => 
        row[key]?.toString().toLowerCase().includes(val)
      );
    });
  
    // Update the rows
    this.rows = temp;
    console.log(temp)
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }

  // modal
  modalOpenDefault(modalDefault) {
    this.modalService.open(modalDefault, {
      centered: true
    });
  }
  modalOpenLG(modalLG) {
    this.isSavedSuccess = false;
    this.tempCategoryGuid = this.generateGuid();
    this.uploadedImagePath = '';
    
    const modalRef = this.modalService.open(modalLG, {
      centered: true,
      size: 'lg'
    });
    
    modalRef.result.then(
      (result) => {
        if (!this.isSavedSuccess) {
          this.discardUploadedImage();
        }
      },
      (reason) => {
        this.discardUploadedImage();
      }
    );
  }
  deletedItemId: any
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }

  confirmDelete(){
    if(this.deletedItemId){
      this.api.deleteEventCategory(this.deletedItemId).subscribe({
        next: (response) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم الحذف بنجاح ✅');
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        },error: (error: HttpErrorResponse) => {
          this.toastService.show('خطأ أثناء الحذف ❌');
        }
      })
    }
  }

  // upload image functions
  previewUrl1: string | ArrayBuffer | null = null;
  previewUrl2: string | ArrayBuffer | null = null;
  onFileSelected(event: Event,type: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      
      const reader = new FileReader();
      reader.onload = () => {
        if (type === 'iconEvent') {
          this.previewUrl1 = reader.result;
        } else if (type === 'iconEvent2') {
          this.previewUrl2 = reader.result;
        }
      };
      reader.readAsDataURL(file);

      let entityId = '';
      if (type === 'iconEvent') {
        if (!this.tempCategoryGuid) {
          this.tempCategoryGuid = this.generateGuid();
        }
        entityId = this.tempCategoryGuid;
      } else {
        entityId = this.idToEdit;
      }

      this.isUploadingImage = true;
      const entityType = 2; // Event
      const usageType = 1;

      this.mediaService.uploadMedia(file, entityId, entityType, usageType).subscribe({
        next: (response) => {
          this.uploadedImagePath = response.filePath;
          this.isUploadingImage = false;
          this.eventCatForm.patchValue({
            image: response.filePath
          });
          this.toastService.show('تم رفع الصورة بنجاح ✅');
        },
        error: (error: HttpErrorResponse) => {
          this.isUploadingImage = false;
          this.toastService.show('خطأ أثناء رفع الصورة ❌');
        }
      });
    }
  }

  // download files
  downloadFile(file: string){
    if(file == 'pdf'){
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير فئات الفعاليات</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0]).map(header => `<th>${header}</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows.map(row => `
                  <tr>
                    ${Object.keys(row).map(key => `<td>${row[key].toString().replace(/<[^>]*>/g, '')}</td>`).join("")}
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    }else if(file == 'excel'){
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }
    
      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility
    
      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]); 
      csvContent += headers.join(",") + "\n";
    
      // Add Table Rows
      this.rows.forEach(row => {
        const rowData = headers.map(header => {
          let cell = row[header] ? row[header].toString() : '';
          return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, '')}"`; // Escape quotes & remove HTML
        }).join(",");
        csvContent += rowData + "\n";
      });
    
      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "event_Categories.csv");
      document.body.appendChild(link);
    
      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }

  color: string = '#3F8260';
  save(){
    this.eventCatForm.markAllAsTouched();
    if(!this.eventCatForm.get('nameAr')?.value){
      this.color = '#c72828'
      this.toastService.show('يرجى إدخال اسم الفئة بالعربية');
      return;
    }
    if(!this.eventCatForm.get('nameEn')?.value){
      this.color = '#c72828'
      this.toastService.show('يرجى إدخال اسم الفئة بالانجليزية');
      return;
    }
    if(!this.uploadedImagePath){
      this.color = '#c72828'
      this.toastService.show('يرجى تحميل صورة الغلاف والرأس');
      return;
    }
    if(this.isUploadingImage){
      this.toastService.show('جاري رفع الصورة، يرجى الانتظار ⏳');
      return;
    }
    if(this.eventCatForm.valid){
      const body = {
        nameAr: this.eventCatForm.get('nameAr')?.value,
        nameEn: this.eventCatForm.get('nameEn')?.value,
        image: this.uploadedImagePath
      };
      
      this.api.addEventCategory(body).subscribe({
        next: (response) => {
          if(response.success == true){
            this.isSavedSuccess = true;
            if (this.uploadedImagePath) {
              this.mediaService.keepMedia(this.uploadedImagePath).subscribe();
            }
            this.toastService.show('تم الاضافة بنجاح ✅');
            this.modalService.dismissAll();
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        },error: (error: HttpErrorResponse) => {
          if(error.error?.message == 'there is already existed category with same name'){
            this.toastService.show('الفئة موجودة بالفعل ❌');
          }else{
            this.toastService.show('حدث خطأ أثناء الحفظ برجاء المحاولة مره اخري ❌');
          }
        }
      })
    }
  }

  edit(){
    console.log(this.eventCatForm.value)
    if(!this.uploadedImagePath){
      this.toastService.show('يرجى تحميل صورة الغلاف والرأس');
      return;
    }
    if(this.isUploadingImage){
      this.toastService.show('جاري رفع الصورة، يرجى الانتظار ⏳');
      return;
    }
    if(this.eventCatForm.valid){
      const body = {
        id: this.idToEdit,
        nameAr: this.eventCatForm.get('nameAr')?.value,
        nameEn: this.eventCatForm.get('nameEn')?.value,
        image: this.uploadedImagePath
      };
      
      this.api.editEventCategory(body).subscribe({
        next: (response) => {
          if(response.success == true){
            this.isSavedSuccess = true;
            if (this.uploadedImagePath) {
              this.mediaService.keepMedia(this.uploadedImagePath).subscribe();
            }
            this.toastService.show('تم التعديل بنجاح ✅');
            this.modalService.dismissAll();
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        },error: (error: HttpErrorResponse) => {
          this.toastService.show('حدث خطأ أثناء الحفظ برجاء المحاولة مره اخري ❌');
        }
      })
    }
  }

  reset(){
    this.eventCatForm.patchValue({
      id: '',
      nameAr: '',
      nameEn: '',
      image: ''
    });
    this.previewUrl1 = null;
    this.previewUrl2 = null;
    this.uploadedImagePath = '';
    this.tempCategoryGuid = '';
    this.isSavedSuccess = false;
  }

  discardUploadedImage() {
    if (this.uploadedImagePath && !this.isSavedSuccess) {
      const isNewUpload = this.dataToEdit ? (this.uploadedImagePath !== this.dataToEdit.image) : true;
      if (isNewUpload) {
        this.mediaService.deleteMedia(this.uploadedImagePath).subscribe({
          next: () => {
            console.log('Temporary uploaded image discarded:', this.uploadedImagePath);
          },
          error: (err) => {
            console.error('Failed to discard image:', err);
          }
        });
      }
    }
    this.reset();
  }

  getImagePath(path: string): string {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
      return path;
    }
    try {
      const backendUrl = new URL(this.api.baseURL);
      const cleanPath = path.startsWith('/') ? path.substring(1) : path;
      return `${backendUrl.protocol}//${backendUrl.host}/${cleanPath}`;
    } catch (e) {
      return path;
    }
  }

  generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  dataToEdit: any
  idToEdit: any
  loadFormData(id: string){
    this.isSavedSuccess = false;
    this.uploadedImagePath = '';
    if(id){
      this.idToEdit = id
      this.api.showEventCategory(id).subscribe({
        next: (response) => {
          this.dataToEdit = response.data
          console.log(this.dataToEdit)
          this.eventCatForm.patchValue({
            id: this.dataToEdit.id,
            nameAr: this.dataToEdit.nameAr,
            nameEn: this.dataToEdit.nameEn,
            image: this.dataToEdit.image
          })
          this.uploadedImagePath = this.dataToEdit.image;
          this.previewUrl2 = this.getImagePath(this.dataToEdit.image);
        },error: (error: HttpErrorResponse) => {

        }
      })
    }
  }

  arabicTextValidator(control: AbstractControl) {
    if (!control.value) return null; // skip validation if empty
  
    const arabicRegex = /^[\u0600-\u06FF\s\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF0-9٠-٩\-\&\/\(\)\.,]+$/;
    return arabicRegex.test(control.value) ? null : { arabicOnly: true };
  }
  englishTextValidator(control: AbstractControl) {
    if (!control.value) return null;
    const englishRegex = /^[A-Za-z0-9\s\-\&\/\(\)\.,]+$/;
    return englishRegex.test(control.value) ? null : { englishOnly: true };
  }
}

